import * as z from "zod";

export const roleContactSchema = z.object({
  email: z.string().optional(),
  phone: z.string().optional(),
});

export type RoleContact = z.infer<typeof roleContactSchema>;
